import {
    Component,
    EventEmitter,
    inject,
    Input,
    Output,
    ViewChild,
    ViewEncapsulation,
} from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { CerrixLabelComponent } from "@app/shared/atoms/cerrix-label/cerrix-label.component";
import { CerrixTextareaComponent } from "@app/shared/atoms/cerrix-textarea/cerrix-textarea.component";
import { CerrixInstructionsIconComponent } from "@app/shared/cerrix-instructions-icon/cerrix-instructions-icon.component";
import { CerrixInputValidationErrorsDirective } from "@app/shared/directives/cerrix-input-fields/cerrix-input-validation-errors.directive";
import { CerrixInputValidationMaxLengthDirective } from "@app/shared/directives/cerrix-input-fields/cerrix-input-validation-max-length.directive";
import { CerrixDialogService } from "@app/shared/organisms/cerrix-dialog/cerrix-dialog-service.component";
import { CerrixTextareaDialogComponent } from "@app/shared/organisms/cerrix-textarea-dialog/cerrix-textarea-dialog.component";

@Component({
    selector: "cerrix-textarea-group",
    imports: [
        MatIcon,
        CerrixTextareaComponent,
        CerrixLabelComponent,
        CerrixInstructionsIconComponent,
        CerrixTextareaDialogComponent,
        CerrixInputValidationErrorsDirective,
        CerrixInputValidationMaxLengthDirective,
    ],
    templateUrl: "./cerrix-textarea-group.component.html",
    styleUrl: "./cerrix-textarea-group.component.scss",
    encapsulation: ViewEncapsulation.None,
})
export class CerrixTextareaGroupComponent {
    @Input() placeholder: string = "";
    @Input() disabled: boolean = false;
    @Input() readOnly: boolean | null = null;
    @Input() infoText: string = "";
    @Input() resize: boolean = false;
    @Input() maxLength: number = 32767;
    @Input() name: string = "";
    @Input() rows: number = 4;
    @Input() textareaDialogTitle: string = "";
    @Input() value: string = "";
    @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

    @ViewChild("textareaDialog") private textareaDialog: CerrixTextareaDialogComponent;

    private _dialogService = inject(CerrixDialogService);

    public openTextareaDialog(): void {
        this.textareaDialog.value = this.value;
        this._dialogService.openDialog(this.name + "-dialog");
    }

    public closeTextareaDialog(newValue?: string): void {
        if (newValue !== undefined) {
            this.valueChange.emit(newValue);
        }
        this._dialogService.closeDialog(this.name + "-dialog");
    }
}
